import React from "react";
import { useNavigate } from "react-router-dom";

import { EmailButton, WhatsAppButton, GrayButton } from "../../styles/buttons";
import { OnlyLogo } from "../../styles/logos";
import {
  BoxTitle,
  BoxSubTitle,
  LeftBoxTitle,
  LeftBoxSubTitle,
} from "../../styles/texts";
import {
  InvisibleExternalBox,
  GrayBorderBox,
  InternalLeftBox,
} from "../../styles/boxes";

const SelectMethod: React.FC = () => {
  const navigate = useNavigate();

  const handleMethodSelection = (method: "email" | "whatsapp") => {
    navigate(`/sendlink?method=${method}`);
  };

  return (
    <InvisibleExternalBox w="434px" h="459px">
      <GrayBorderBox w="459px" h="261px">
        <OnlyLogo h="24px" />
        <BoxTitle>Iniciar Sesión</BoxTitle>
        <BoxSubTitle>
          Elige por dónde quieres recibir tu link de acceso
        </BoxSubTitle>

        <EmailButton
          label="Email"
          onClick={() => handleMethodSelection("email")}
          w="395px"
          h="44px"
        />

        <WhatsAppButton
          label="WhatsApp"
          onClick={() => handleMethodSelection("whatsapp")}
          w="395px"
          h="44px"
        />
      </GrayBorderBox>

      <GrayBorderBox w="459px" h="157px">
        <InternalLeftBox w="395px" h="150px" g="8px">
          <LeftBoxTitle>¿No tienes cuenta?</LeftBoxTitle>
          <LeftBoxSubTitle>
            Primero debes iniciar un proceso de cotización.
          </LeftBoxSubTitle>
          <GrayButton
            label="Cotizar"
            onClick={() => window.open("https://ruuf.cl", "_blank")}
            w="100px"
            h="32px"
            icon="righthead"
          />
        </InternalLeftBox>
      </GrayBorderBox>
    </InvisibleExternalBox>
  );
};

export default SelectMethod;
